// This file was generated automatically by set-version script.
// - Version to be injected from git tag metadata.
// - Build Timestamp to be injected at build time.

export const APP_VERSION = '0.0.53';
export const APP_BUILD_TIME = '2022-02-08T21:48:31.155Z';
